var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "w-row",
    { staticClass: "root" },
    [
      _c(
        "w-col",
        { attrs: { xs: "12" } },
        [
          _c("w-checkbox", {
            attrs: {
              label: _vm.$ctc(
                "labels-to-print-enabled-for-stock-location",
                _vm.locationId
              ),
              value: _vm.value != -1,
            },
            on: {
              input: function ($event) {
                return _vm.setEnabled($event)
              },
            },
          }),
        ],
        1
      ),
      _c(
        "w-col",
        { attrs: { xs: "12", md: "6" } },
        [
          _c("w-input-number", {
            attrs: {
              value: _vm.shownValue,
              min: 0,
              max: _vm.max,
              decimals: 0,
              disabled: _vm.value == -1,
              label: _vm.$ctc(
                "labels-to-print-for-stock-location",
                _vm.locationId
              ),
              fancy: "",
            },
            on: {
              input: function ($event) {
                return _vm.setValue($event)
              },
            },
          }),
        ],
        1
      ),
      _c(
        "w-col",
        { attrs: { xs: "12", md: "6" } },
        [
          _c("app-label-layout-select", {
            attrs: {
              value: _vm.layoutId,
              fancy: "",
              label: _vm.$ctc(
                "label-to-use-layout-for-stock-location",
                _vm.locationId
              ),
              "browse-id": 4,
              "include-empty": "",
            },
            on: {
              input: function ($event) {
                return _vm.setLayoutId($event)
              },
            },
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }